import { SeriesDTO, IChartTooltips, numberFormatting } from "./ChartOptionsForTierParticpation";
import { wcmUrls } from "../shared/constants";
import { legendProperties, LegendProps } from "./DefaultChartOptions";

const bufferLineLabel = '<span class="line-text">Buffer <span id="step-rate-buffer-tooltip"></span></span>';
const stepRateLineLabel = '<span class="line-text">Step Rate <span id="step-rate-tooltip"></span></span>';
const ChartTooltips = [
    {
            title: 'Step Rate',
            url: wcmUrls.stepRateTooltip,
            elementId: 'step-rate-tooltip',
        },
    {
        title: 'Buffer',
        url: wcmUrls.protectionTooltip,
        elementId: 'step-rate-buffer-tooltip',
    }];

    
    const createTickPositions = (params: StepRateParams)  => {

    const tickArray: number[] = [];
    let startTick = Math.floor(params.minDataPoint/10)*10;
    const endTick = Math.ceil(params.maxDataPoint/10)*10;
    
    if (startTick > params.bufferLevel) {
        startTick = params.bufferLevel
    }

    const tickIntervel = endTick > 70 || startTick < -70 ? 20 : 10;

    for (let i = startTick - 10; i <= endTick + 10; i = i + tickIntervel) {
        tickArray.push(i);
    }

    if(params.stepRate && tickArray.indexOf(params.stepRate) === -1) {
        tickArray.push(params.stepRate);
    }

    if(params.bufferLevel && tickArray.indexOf(params.bufferLevel) === -1) {
        tickArray.push(params.bufferLevel);
    }

    tickArray.sort(function(a, b){return a - b});

    return tickArray;
}
/* eslint-disable @typescript-eslint/no-explicit-any */
const yAxisObj = (params: StepRateParams) => {
return {
    tickPositions: createTickPositions(params),
    labels: {
        formatter: function (): string{
            if ((this as any).value === params?.stepRate) { // dynamic values
                return '<span class="label-blue label-bold y-label" aria-hidden="true">' + (this as any).value + '%</span>';
            }
            if ((this as any).value === params?.bufferLevel) { // dynamic values
                return '<span class="label-bold y-label" aria-hidden="true">' + (this as any).value + '%</span>';
            }
            return '<span class="y-label" aria-hidden="true">' + (this as any).value + '%</span>';
        },
        useHTML: true,
        x: -10,
    },
    showLastLabel: false,
    showFirstLabel: true,
    stackLabels: {
        enabled: true,
        formatter: function (): any {
            let stackValue = '';
                
                if ((this as any).x !== 3) {
                    if ((this as any).stack) {
                        // to hide floating 0% in first column check if additional gain series is added
                        if((this as any).x === 0 && (this as any).axis.series.length === 3){
                            // if series added and still trying to plot 0 then hide it
                            if((this as any).points[2]){
                                stackValue = '<span class="dark-blue">' + numberFormatting((this as any).total) + '%</span>';
                            }
                        } else {
                            stackValue = '<span class="dark-blue">' + numberFormatting((this as any).total) + '%</span>';
                        }
                        
                    } else {
                        stackValue = '<span class="light-blue">' + numberFormatting((this as any).total) + '%</span>';
                    }
                }
                return stackValue;
        },
        style: {
            fontSize: '15px',
            fontWeight: 'normal',
            textOutline: false
        },
        useHTML: true
    },
    title: {
        text: null
    },
    gridLineColor: 'transparent',
    plotBands: [
        {
            color: {
                linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                stops: [
                    [0, 'rgba(210, 229, 205, 1)'],
                    [1, 'rgba(210, 229, 205, 0.3)'],
                ]
            },
            from: 0,
            to: params?.stepRate, // 47,  // dynamic value        
        },
        {
            color: {
                linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                stops: [
                    [0, 'rgba(227, 228, 228, 1)'],
                    [1, 'rgba(227, 228, 228, 0.3)'],
                ]
            },
            from: 0,
            to: params?.bufferLevel,    // -10 ;dynamic value - buffer value
        }],
    plotLines: [{
        value: 0,
        width: 3,
        color: '#999999',
        zIndex: 5
    },
    {
        value: params?.stepRate, // dynamic value
        width: 2,
        color: '#07639d',
        zIndex: 3,
        dashStyle: 'dash',
        label: {
            align: 'right',
            textAlign: 'left',
            x: -220,
            y: -5,
            formatter: function () {
                return stepRateLineLabel;
            },
            style: {
                color: '#07639d',
                fontWeight: 'bold',
            },
            useHTML: true,
        }
    },
    {
        value:  params?.bufferLevel , // dynamic value
        width: 1,
        color: '#999999',
        zIndex: 3,
        label: {
            align: 'right',
            textAlign: 'left',
            x: -220,
            y: params?.bufferLevel < -5 ? -10 : -4,
            formatter: function () {
                return bufferLineLabel;
            },
            style: {
                color: '#333333',
                fontWeight: 'bold',
            },
            useHTML: true,
        }
    }]
};
};
const getDownMarketText = (params: StepRateParams) => {
    return  'The account is protected from index losses up to the ' + numberFormatting(params?.bufferLevel * -1) + '% buffer limit.';
}
const getUpMarketText = (params: StepRateParams) => {
    const strategyReturnUp = params.strategyReturnPercentageUp;
    const indexReturnPercentageUp = params.indexReturnPercentageUp;
    const stepRate = params.stepRate;
    const actualStepParRatePercentage = params.actualStepParRate > 0.0 ?numberFormatting(params.actualStepParRate) + '% ' : '';
    console.log("upMarketText", {actualStepParRatePercentage, params});
    const text1 = 'The '+numberFormatting(stepRate)+'% Step Rate is greater than the ' + actualStepParRatePercentage + 'Participation Rate return ('+ numberFormatting(params?.stepParticipationRate) +'% of the index return). Therefore the account is credited '+numberFormatting(stepRate)+'%.';
    const text2 = 'The '+numberFormatting(strategyReturnUp)+'% Participation Rate return ('+ numberFormatting(params?.stepParticipationRate) +'% of the index return) is greater than the Step Rate. Therefore the account is credited '+ numberFormatting(strategyReturnUp) +'%.';
    
    if (stepRate === strategyReturnUp && indexReturnPercentageUp >= 0) {
        return text1;
    } else if (strategyReturnUp > stepRate) {
        return text2;
    } else { 
        return '';
     }
}
const getCustomMarketText = (params: StepRateParams) => {
    const strategyReturnCustom = params.strategyReturnPercentageCustom;
    const indexReturnPercentageCustom = params.indexReturnPercentageCustom;
    const stepRate = params.stepRate;
    const actualStepParRatePercentage = params.actualStepParRate > 0.0 ? numberFormatting(params.actualStepParRate) + '% ' : '';
    console.log("customMarketText", {actualStepParRatePercentage, params});
   const text1 = 'The '+numberFormatting(stepRate)+'% Step Rate is greater than the ' + actualStepParRatePercentage + 'Participation Rate return ('+numberFormatting(params?.stepParticipationRate)+'% of the index return). Therefore the account is credited '+numberFormatting(stepRate)+'%.';
   const text2 = 'The '+numberFormatting(strategyReturnCustom)+'% Participation Rate return ('+numberFormatting(params?.stepParticipationRate)+'% of the index return) is greater than the Step Rate. Therefore the account is credited '+numberFormatting(strategyReturnCustom)+'%.';
    
    if (stepRate === strategyReturnCustom && indexReturnPercentageCustom >= 0) {
        return text1;
    } else if (strategyReturnCustom > stepRate) {
        return text2;
    } else if(indexReturnPercentageCustom <= 0){
        return  getDownMarketText(params);
     } else {
        return '';
     }
}
const xAxisObj = (params: StepRateParams) => {
 return {
    categories: [
        getDownMarketText(params),
        getUpMarketText(params),
        getCustomMarketText(params),
        ''
    ],
    labels: {
        enabled: true,
        y: 50,
        style: {
            fontSize: '14px'
        },
        useHTML: true,
    },
    offset: 0,
    lineWidth: 0,
    lineColor: 'transparent',
};
};
export class ChartOptionsForStepRate  {
    chartTooltips: IChartTooltips[] | undefined;
    stepRateParams: StepRateParams;
    defs = {
        patterns: [{
            id: 'custom-pattern',
            path: {
                d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
                stroke: '#FFFFFF',
                fill: '#183455',
                strokeWidth: 2
            }
        }]
    };
    chart = {
        height: 550,
        type: 'column',
        style: {
            fontFamily: 'Opensans-Regular,Arial,"Helvetica Neue",Helvetica,sans-serif',
        }
    };
    legend: LegendProps = legendProperties;
    title = {
        text: null
    };
    xAxis: object;
    yAxis: object;
    credits = {
        enabled: false
    };
    plotOptions = {
        column: {
            stacking: 'normal',
            opacity: .95
        },
        series: {
            borderRadius: 3,
            borderWidth: 0,
            dataLabels: {
                enabled: false
            }
        }
    };
    tooltip = {
        enabled: false
    };
    series: Array<SeriesDTO>;
    
    constructor(seriesdata: Array<SeriesDTO>,stepRateParams: StepRateParams, legendProps: LegendProps | null){
        this.series = seriesdata;
        this.stepRateParams = stepRateParams;
        
        this.yAxis = yAxisObj(this.stepRateParams);
        this.xAxis = xAxisObj(this.stepRateParams);
        this.chartTooltips = this.stepRateParams?ChartTooltips:undefined;
     
        if (legendProps) {
            this.legend = legendProps;
        }
    }
}

export interface StepRateParams{
    stepRate: number;
    stepParticipationRate: number;
    actualStepParRate: number;
    strategyReturnPercentageCustom: number;
    indexReturnPercentageCustom: number;
    bufferLevel: number;
    minDataPoint: number;
    maxDataPoint: number;
    strategyReturnPercentageUp: number;
    indexReturnPercentageUp: number;
}